import { createReducer, on } from '@ngrx/store';
import {
  ActiveComponentChanged,
  ResetStateFromRouter,
} from 'src/app/shared/actions/eliqua.actions';
import {
  CreateNewPolicy,
  EditPolicyRolesSuccess,
  EditUserPolicy,
  GetUserManagementRolesSuccess,
  PolicyDescriptionChanged,
  PolicyNameChanged,
  ProgressChanged,
  RemoveRole,
  RolesInDocumentChanged,
  SearchFilterChanged,
  UserSubmitted,
} from '../actions/policy-document.actions';
import { CloseSidenav } from '../actions/side-nav.actions';
import { GetPolicyDocumentsSuccess } from '../actions/user-search.actions';
import { PolicyDocumentsState, RolesInDocument } from '../models/user.models';

const initialState: PolicyDocumentsState = {
  policies: '',
  policyInEdit: '',
  policyName: '',
  policyDescription: '',
  rolesInDoc: [],
  addRolesInDoc: '',
  displayedColumns: [],
  submit: false,
  searchFilter: '',
  createNewPolicy: false,
  policyLoaded: false,
};

export const PolicyDocumentsReducer = createReducer(
  initialState,
  on(GetPolicyDocumentsSuccess, (state, { res }) => ({
    ...state,
    policies: res,
  })),
  on(ProgressChanged, (state) => ({
    ...state,
    policyLoaded: true,
  })),
  on(PolicyNameChanged, (state, { policyName }) => ({
    ...state,
    policyName,
  })),
  on(PolicyDescriptionChanged, (state, { policyDescription }) => ({
    ...state,
    policyDescription,
  })),
  on(RolesInDocumentChanged, (state, { role }) => {
    let rolesInDoc = [...state.rolesInDoc];
    let addRolesInDoc = Object.assign({}, state.addRolesInDoc);
    if (role && !rolesInDoc.includes(role)) {
      rolesInDoc = [...rolesInDoc, role];
    }

    return { ...state, rolesInDoc, addRolesInDoc };
  }),
  on(EditUserPolicy, (state, { row }) => {
    return {
      ...state,
      policyInEdit: row,
      policyName: row.policyDocumentName,
      policyDescription: row?.policyDocumentNotes ? row.policyDocumentNotes : '',
    };
  }),
  on(GetUserManagementRolesSuccess, (state, { res, literals }) => {
    let allRoles: any = res;
    const addRolesInDoc = allRoles.reduce((addRolesInDoc: any, role: RolesInDocument) => {
      addRolesInDoc[role.roleId] = {
        roleName: role.roleName,
        roleDescription: literals.literals[role.roleDescription] ?? 'No Description',
      };
      return addRolesInDoc;
    }, {});

    return {
      ...state,
      addRolesInDoc,
      displayedColumns: ['RoleName', 'Delete'],
    };
  }),
  on(EditPolicyRolesSuccess, (state, { res }) => ({
    ...state,
    rolesInDoc: Object.values(res.policyDocumentRolesMap).sort() as string[],
  })),
  on(RemoveRole, (state, { role }) => ({
    ...state,
    rolesInDoc: state.rolesInDoc.filter((currRole: string) => currRole !== role),
  })),
  on(SearchFilterChanged, (state, { searchFilter }) => ({
    ...state,
    searchFilter,
  })),
  on(UserSubmitted, (state) => ({
    ...state,
    submit: true,
  })),
  on(CreateNewPolicy, (state) => ({
    ...state,
    createNewPolicy: true,
  })),
  on(CloseSidenav, (state) => ({
    ...state,
    policyInEdit: '',
    policyName: '',
    policyDescription: '',
    rolesInDoc: [],
    submit: false,
    searchFilter: '',
    createNewPolicy: false,
    policyLoaded: false,
  })),
  on(ActiveComponentChanged, (state) => ({
    ...state,
    policyInEdit: '',
    policyName: '',
    policyDescription: '',
    rolesInDoc: [],
    addRolesInDoc: '',
    displayedColumns: [],
    submit: false,
    searchFilter: '',
    createNewPolicy: false,
    policyLoaded: false,
  })),
  on(ResetStateFromRouter, () => ({
    ...initialState,
  })),
);
